<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<router-link :to="`/fzorganlicenseapplys/${activeName}/${pageIndex}`">
						<i class="el-icon-arrow-left" style="cursor: pointer;"></i>
						牌照查看 / 牌照详情
					</router-link>
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="purchasesee-box">
			<p class="purchasesee-title">车主及业务员信息</p>
			<div class="purchasesee-padding">
				<ul class="seelicense-item1">
					<li>
						车主:
						<span>{{seelicenseApplylist.ownerName}}</span>
					</li>
					<li>
						手机号:
						<span>{{seelicenseApplylist.ownerCellphoneNumber}}</span>
					</li>
					<li>
						办理业务员:
						<span>{{seelicenseApplylist.applicantName}}</span>
					</li>
				</ul>
				<ul class="seelicense-item1">
					<li>
						地区:
						<span>{{seelicenseApplylist.provinceName}}{{seelicenseApplylist.cityName}}</span>
					</li>
					<li>
						身份证号:
						<span>{{seelicenseApplylist.ownerIdentityCards}}</span>
					</li>
				</ul>
				<ul class="seelicense-itemphoto" v-if="seelicenseApplylist.ownerIdentityCardsPhoto">
					<li>身份证照片:</li>
					<li v-for="item in seelicenseApplylist.ownerIdentityCardsPhoto">
						<img :src="'/api/static'+item" alt />
					</li>
				</ul>
				<!-- <ul class="seelicense-item1">
					<li>车主:{{seelicenseApplylist.ownerName}}</li> 
					<li>办理业务员:{{seelicenseApplylist.applicantName}}</li>
                </ul>-->
			</div>

			<p class="purchasesee-title" style="border-left: none;"></p>

			<p class="purchasesee-title">基本信息</p>
			<div class="purchasesee-padding">
				<ul class="seelicense-item3">
					<li>
						设备编号:
						<span>{{seelicenseApplylist.equipmentCode}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						环保编码：
						<span>{{seelicenseApplylist.environmentalProtectionNumber}}</span>
					</li>
					<li>
						排放登记:
						<span>{{seelicenseApplylist.emissionRegistration}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						发动机功率：
						<span>{{seelicenseApplylist.enginePower}}</span>
					</li>
					<li>
						机械品牌:
						<span>{{seelicenseApplylist.machineryBrand}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						机械颜色：
						<span>{{seelicenseApplylist.machineryColor}}</span>
					</li>
					<li>
						机械类型:
						<span>{{seelicenseApplylist.machineryType}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						生产国别：
						<span>{{seelicenseApplylist.productionCountry}}</span>
					</li>
					<li>
						整机架号:
						<span>{{seelicenseApplylist.frameNo}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						燃油类型：
						<span>{{seelicenseApplylist.fuelType}}</span>
					</li>
					<li>
						发动机号:
						<span>{{seelicenseApplylist.engineNumber}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						整机质量：
						<span>{{seelicenseApplylist.overallQuality}}</span>
					</li>
					<li>
						出厂日期:
						<span>{{seelicenseApplylist.productionDateStr}}</span>
					</li>
				</ul>
				<ul class="seelicense-item3">
					<li>
						核载质量：
						<span>{{seelicenseApplylist.nuclearInformation}}</span>
					</li>
					<li>
						生产厂家：
						<span>{{seelicenseApplylist.factory}}</span>
					</li>
				</ul>
				<ul class="seelicense-itemphoto" v-if="seelicenseApplylist.mechanicalPictures">
					<li>机械图片:</li>
					<li v-for="item in seelicenseApplylist.mechanicalPictures">
						<img :src="'/api/static'+item" alt />
					</li>
				</ul>
			</div>
			<p class="purchasesee-title">邮寄地址</p>
			<div class="purchasesee-padding">
				<p class="seelicense-item5">
					收货人姓名:
					<span>{{seelicenseApplylist.shippingName}}</span>
				</p>
				<p class="seelicense-item5">
					收货人手机号:
					<span>{{seelicenseApplylist.shippingCellphoneNumber}}</span>
				</p>
				<p class="seelicense-item5">
					收货地址:
					<span>{{seelicenseApplylist.shippingAddress}}</span>
				</p>
			</div>
			<p class="purchasesee-title">易车信息</p>
			<div class="purchasesee-padding">
				<ul class="seelicense-item4"
					v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards">
					<li
						v-if="seelicenseApplylist.receiverName || seelicenseApplylist.receiverCellphoneNumber || seelicenseApplylist.receiverIdentityCards">
						车主变更</li>
					<li v-if="seelicenseApplylist.receiverName">接收人:{{seelicenseApplylist.receiverName}}</li>
					<li v-if="seelicenseApplylist.receiverCellphoneNumber">接收人电话:
						{{seelicenseApplylist.receiverCellphoneNumber}}
					</li>
					<li v-if="seelicenseApplylist.receiverIdentityCards">接收人证件号:
						{{seelicenseApplylist.receiverIdentityCards}}
					</li>
				</ul>
				<p class="seelicense-item2" v-else>无</p>
			</div>
		</div>

		<p class="purchasesee-text2" style="margin-top: 30px;">
			<el-button type="primary" class="handle-del mr10" @click="ownerchangebtn('ownerchangeform',1)">车主变更
			</el-button>
			<!-- <el-button
                type="primary"
                class="handle-del mr10"
                @click="ownerchangebtn('ownerchangeform',2)"
            >车辆变更</el-button> -->
			<el-button type="primary" class="handle-del mr10" @click="ownerchangebtn2">车辆变更</el-button>
			<el-button type="primary" class="handle-del mr10">
				<router-link :to="'/fz_alterlicense/'+licenseApplyId" style="color: #fff;">信息修改</router-link>
			</el-button>
		</p>

		<!-- 车主变更 -->
		<el-dialog class="branch-dialog" title="变更信息" :visible.sync="ownerchangeVisible" width="600px">
			<el-form ref="ownerchangeform" :model="ownerchangeform" :rules="ownerchangerules">
				<el-form-item label="接收人姓名" prop="receiverName">
					<el-input v-model="ownerchangeform.receiverName"></el-input>
				</el-form-item>
				<el-form-item label="接收人电话" prop="receiverCellphoneNumber">
					<el-input v-model="ownerchangeform.receiverCellphoneNumber"></el-input>
				</el-form-item>
				<el-form-item label="接收人证件号" prop="receiverIdentityCards">
					<el-input v-model="ownerchangeform.receiverIdentityCards"></el-input>
				</el-form-item>

				<el-form-item ref="ownerIdentityCardsPhoto" label="添加身份证正面照" prop="ownerIdentityCardsPhoto">
					<el-upload action="#" list-type="picture-card" :show-file-list="false"
						:http-request="uploadcardsPhotoPreview" :before-upload="beforeAvatarUpload">
						<img width="100%" height="100%" v-if="ownerchangeform.ownerIdentityCardsPhoto"
							:src="'/api/static'+ownerchangeform.ownerIdentityCardsPhoto" class="avatar" />
						<i v-else class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item ref="ownerIdentityCardsPhotoReverse" label="添加身份证反面照"
					prop="ownerIdentityCardsPhotoReverse">
					<el-upload action="#" list-type="picture-card" :show-file-list="false"
						:http-request="uploadcardsPhotoReversePreview" :before-upload="beforeAvatarUpload">
						<img width="100%" height="100%" v-if="ownerchangeform.ownerIdentityCardsPhotoReverse"
							:src="'/api/static'+ownerchangeform.ownerIdentityCardsPhotoReverse" class="avatar" />
						<i v-else class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="ownerchangeSave('ownerchangeform')">确 定</el-button>
				<el-button @click="ownerchangeVisible = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 车辆变更 -->
		<el-dialog class="carInformationDialog" title="变更信息" :visible.sync="ownerchangeVisible2" width="600px">
			<el-form :model="carInformation" ref="carInformation" :label-position="labelPosition" label-width="100px"
				:rules="carRules">
				<el-form-item label="设备编码" prop="equipmentCode">
					<el-input v-model="carInformation.equipmentCode" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="整机架号">
					<el-input v-model="carInformation.frameNo"></el-input>
				</el-form-item>
				<el-form-item label="环保编号">
					<el-input v-model="carInformation.environmentalProtectionNumber"></el-input>
				</el-form-item>
				<el-form-item label="燃油类型">
					<el-input v-model="carInformation.fuelType"></el-input>
				</el-form-item>
				<el-form-item label="排放登记">
					<el-input v-model="carInformation.emissionRegistration"></el-input>
				</el-form-item>
				<el-form-item label="发动机号">
					<el-input v-model="carInformation.engineNumber"></el-input>
				</el-form-item>
				<el-form-item label="发动机功率">
					<el-input v-model="carInformation.enginePower"></el-input>
				</el-form-item>
				<el-form-item label="整机质量">
					<el-input v-model="carInformation.overallQuality"></el-input>
				</el-form-item>
				<el-form-item label="机械品牌">
					<el-input v-model="carInformation.machineryBrand"></el-input>
				</el-form-item>
				<el-form-item label="出厂日期">
					<el-date-picker v-model="carInformation.productionDateStr" type="date" value-format="yyyy-MM-dd"
						placeholder="出厂日期"></el-date-picker>
				</el-form-item>
				<el-form-item label="机械颜色">
					<el-input v-model="carInformation.machineryColor"></el-input>
				</el-form-item>
				<el-form-item label="核载信息">
					<el-input v-model="carInformation.nuclearInformation"></el-input>
				</el-form-item>
				<el-form-item label="机械类型">
					<el-input v-model="carInformation.machineryType"></el-input>
				</el-form-item>
				<el-form-item label="生产国">
					<el-input v-model="carInformation.productionCountry"></el-input>
				</el-form-item>
				<el-form-item label="生产厂家">
					<el-input v-model="carInformation.factory"></el-input>
				</el-form-item>
				<el-form-item ref='ownerIdentityCardsPhoto' label="添加机械图片">
					<el-upload action="#" list-type="picture-card" :show-file-list="false"
						:http-request="uploadMachineryPhoto" :before-upload="beforeAvatarUpload">
						<img width="100%" height="100%" v-if="carInformation.mechanicalPictures"
							:src="'/api/static'+carInformation.mechanicalPictures" class="avatar">
						<i v-else class="el-icon-plus"></i>

					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="carInformationSave('carInformation')">确 定</el-button>
				<el-button @click="carInformationCancel">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getLicenseApply,
		examineOrganizationLicenseApply,
		savePcMechanicsTransactionApply,
		savePcMechanicsTransactionApply1
	} from '@/api/index';
	export default {
		name: 'fz_seeLicenseapplysfzorgan',
		data() {
			var validPhone = (rule, value, callback) => {
				// debugger
				const phoneReg =
					/^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
				if (!value) {
					return callback(new Error('电话号码不能为空'))
				} else if (!Number.isInteger(+value)) {
					callback(new Error('请输入数字值'))
				} else {
					if (phoneReg.test(value)) {
						callback()
					} else {
						callback(new Error('电话号码格式不正确'))
					}
				}
			};
			var validIdNum = (rule, value, callback) => {
				const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
				if (!value) {
					return callback(new Error('证件号码不能为空'))
				} else {
					callback()
				}
			};
			return {
				ownerchangeVisible2: false,
				labelPosition: 'right',
				licenseApplyId: '',
				pageIndex: this.$route.params.pageIndex,
				activeName: this.$route.params.activeName,
				seelicenseApplylist: {}, //查看
				seelicenseVos: [],
				seenumberprice: [],


				mechanicsId: '', //必传
				isRetainLicenseNumber: '', //区别车主变更or车辆变更
				ownerchangeVisible: false,
				ownerchangeform: {
					receiverName: '',
					receiverCellphoneNumber: '',
					receiverIdentityCards: '',
					receiverIdentityCardsPhoto: '',

					ownerIdentityCardsPhoto: '',
					ownerIdentityCardsPhotoReverse: '',

				}, //车主变更or车辆变更
				ownerchangerules: {
					receiverName: [{
						required: true,
						message: '请输入接收人姓名',
						trigger: ['blur', 'change']
					}],
					receiverCellphoneNumber: [{
						required: true,
						validator: validPhone,
						trigger: ['blur', 'change']
					}],
					receiverIdentityCards: [{
						required: true,
						validator: validIdNum,
						trigger: ['blur', 'change']
					}],

					ownerIdentityCardsPhoto: [{
						required: true,
						message: '请上传身份证正面照',
						trigger: 'change'
					}],
					ownerIdentityCardsPhotoReverse: [{
						required: true,
						message: '请上传身份证反面照',
						trigger: 'change'
					}]
					// receiverIdentityCardsPhoto: [
					// 	{ required: true, message: '证件照', trigger: '[blur,change]' }
					// ],
				}, //添加表单验证


				// 车辆变更信息
				carInformation: {

					mechanicsId: '',
					isRetainLicenseNumber: 2,
					// 设备编号
					equipmentCode: '',
					// 整机架号
					frameNo: '',
					// 环保编号
					environmentalProtectionNumber: '',
					// 燃油类型
					fuelType: '',
					// 排放登记
					emissionRegistration: '',
					// 发动机号
					engineNumber: '',
					// 发动机功率
					enginePower: '',
					// 整机质量
					overallQuality: '',
					// 机械品牌
					machineryBrand: '',
					// 出厂日期
					productionDateStr: '',
					// 机械颜色
					machineryColor: '',
					// 核载信息
					nuclearInformation: '',
					// 机械类型
					machineryType: '',
					// 生产国
					productionCountry: '',
					// 生产厂家
					factory: '',
					// 机械照片
					mechanicalPictures: '',
				},
				carRules: {
					equipmentCode: [{
						required: true,
						message: '请输入设备编码',
						trigger: 'blur'
					}, ]
				},

				dialogImageUrl: '',
				dialogVisible: false,
				picList: [],
				fileList: [],
				imgArr: [],
				showUpload: false
			};
		},
		created() {
			this.licenseApplyId = this.$route.params.licenseApplyId;
			// 查看
			this.fz_getLicenseApplylist();
		},
		methods: {
			fz_getLicenseApplylist() {
				getLicenseApply({
					"licenseApplyId": this.licenseApplyId
				}).then(res => {
					this.seelicenseApplylist = res.data;
					this.mechanicsId = res.data.mechanicsId;

					if (res.data.ownerIdentityCardsPhoto) {
						this.seelicenseApplylist.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(
							',');
					}
					if (res.data.mechanicalPictures) {
						this.seelicenseApplylist.mechanicalPictures = res.data.mechanicalPictures.split(',');
					}
				});
			},
			// 证件照
			uploadcardsPhotoPreview(item) {
				const _file = item.file;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method: 'post',
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					url: "/api/homepage/uploadImages",
					data: formData,
					crossDomain: true,
					cache: false
				}).then(res => {
					this.$refs.ownerIdentityCardsPhoto.clearValidate();
					this.ownerchangeform.ownerIdentityCardsPhoto = res.data.data[0];
				}).catch(() => {
					this.$message.error('上传失败，请重新上传');
				})

			},
			//身份证反面照
			uploadcardsPhotoReversePreview(item) {
				const _file = item.file;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method: 'post',
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					url: "/api/homepage/uploadImages",
					data: formData,
					crossDomain: true,
					cache: false
				}).then(res => {
					this.$refs.ownerIdentityCardsPhotoReverse.clearValidate();
					this.ownerchangeform.ownerIdentityCardsPhotoReverse = res.data.data[0];
				}).catch(() => {
					this.$message.error('上传失败，请重新上传');
				})
			},

			// 机械图片
			uploadMachineryPhoto(item) {
				const _file = item.file;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method: 'post',
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					url: "/api/homepage/uploadImages",
					data: formData,
					crossDomain: true,
					cache: false
				}).then(res => {
					this.carInformation.mechanicalPictures = res.data.data[0];
				}).catch(() => {
					this.$message.error('上传失败，请重新上传');
				})
			},

			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg'
				const isPng = file.type === 'image/png'
				const isLt2M = file.size / 1024 / 1024 < 2

				if (!isJPG && !isPng) {
					this.$message.error('上传图片只能是 JPG或png 格式!')
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!')
				}
				return (isJPG || isPng) && isLt2M
			},


			// 车主变更
			ownerchangebtn(formName, tag) {
				
				this.isRetainLicenseNumber = tag;
				this.ownerchangeVisible = true;
				//重置表单数据
				this.$nextTick(() => {
					this.$refs. [formName].resetFields();
				})
			},
			// 车辆变更
			ownerchangebtn2() {
				this.ownerchangeVisible2 = true
				this.carInformation.equipmentCode = this.seelicenseApplylist.equipmentCode
				
			},

			// 车辆变更保存按钮
			carInformationSave(formName) {
				
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.carInformation.isRetainLicenseNumber = 2;
						this.carInformation.mechanicsId = this.mechanicsId;
						savePcMechanicsTransactionApply1(this.carInformation).then(res => {
							if (res.code == 0) {
								// 获取数据成功后的其他操作
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.fz_getLicenseApplylist();
								this.ownerchangeVisible2 = false;
								Object.keys(this.carInformation).forEach(key => {
									this.carInformation[key] = ''
								});
							} else if (res.code == 1) {
								this.$message({
									message: res.message,
									type: 'warning'
								});
							} else {
								this.$message({
									message: '报错啦!',
									type: 'warning'
								});
							}
						});
					} else {
						return false;
					}
				});
			},

			// 车辆变更取消按钮
			carInformationCancel() {
				// 将对象中的所有key值赋空
				Object.keys(this.carInformation).forEach(key => {
					this.carInformation[key] = ''
				});
				this.ownerchangeVisible2 = false
			},

			// 车主变更确定按钮
			ownerchangeSave(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.ownerchangeform.receiverIdentityCardsPhoto = this.ownerchangeform
							.ownerIdentityCardsPhoto + ',' + this.ownerchangeform.ownerIdentityCardsPhoto;
						this.ownerchangeform.isRetainLicenseNumber = this.isRetainLicenseNumber;
						this.ownerchangeform.mechanicsId = this.mechanicsId;
						savePcMechanicsTransactionApply(this.ownerchangeform).then(res => {
							if (res.code == 0) {
								// 获取数据成功后的其他操作
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.fz_getLicenseApplylist();
								this.ownerchangeVisible = false;
							} else if (res.code == 1) {
								this.$message({
									message: res.message,
									type: 'warning'
								});
							} else {
								this.$message({
									message: '报错啦!',
									type: 'warning'
								});
							}
						});
					} else {
						return false;
					}
				});
			},

			// 通过
			passseeApply() {
				var that = this;
				var organlaid = this.seeorganizationLicenseApplyId.split(',');
				this.$confirm('确定要通过吗？', '提示', {
					type: 'warning'
				}).then(() => {
					examineOrganizationLicenseApply({
						isPass: 1,
						organizationLicenseApplyIds: organlaid
					}).then(res => {
						// 获取数据成功后的其他操作
						this.$router.push('/organizationlicenseapply');
						this.$message({
							message: res.message,
							type: 'success'
						});
						listTaskRemindNum({}).then(ress => {
							this.$store.state.totalNum = ress.data.totalNum;
						});
					});
				}).catch(() => {});



			},
			// 回退
			fallbackseeApply() {
				var that = this;
				var organlaid = this.seeorganizationLicenseApplyId.split(',');
				this.$confirm('确定要退回吗？', '提示', {
					type: 'warning'
				}).then(() => {
					examineOrganizationLicenseApply({
						isPass: 2,
						organizationLicenseApplyIds: organlaid
					}).then(res => {
						// 获取数据成功后的其他操作
						this.$router.push('/organizationlicenseapply');
						this.$message({
							message: res.message,
							type: 'success'
						});
						console.log(res);
						listTaskRemindNum({}).then(ress => {
							this.$store.state.totalNum = ress.data.totalNum;
						});
					});
				}).catch(() => {});

			},
		}
	};
</script>

<style scoped>
	.purchasesee-box {
		background: #fff;
		padding: 20px 0;
	}

	.purchasesee-title {
		height: 30px;
		line-height: 30px;
		background: #f0f0f0;
		font-size: 16px;
		font-weight: 600;
		letter-spacing: 2px;
		border-left: 5px solid #437af4;
		text-indent: 30px;
	}

	.purchasesee-padding {
		padding: 20px 0;
	}

	.seelicense-item1 {
		display: flex;
		display: -webkit-flex;
		padding: 0 35px;
		list-style: none;
		color: #666;
		letter-spacing: 1px;
		margin-bottom: 20px;
	}

	.seelicense-item1 li {
		width: 200px;
		margin-right: 20px;
	}

	.seelicense-item1 li:last-child {
		flex: 1;
	}

	.seelicense-itemphoto {
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
		list-style: none;
		padding-left: 35px;
		color: #666;
	}

	.seelicense-itemphoto li {
		width: 200px;
		margin-right: 20px;
	}

	.seelicense-itemphoto li:first-child {
		width: 100px;
	}

	.seelicense-itemphoto li img {
		width: 100%;
	}

	.seelicense-item2 {
		padding: 0 35px;
		margin-top: 15px;
		color: #666;
		letter-spacing: 1px;
	}

	.seelicense-item3 {
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
		padding: 0 35px;
		list-style: none;
		color: #666;
		letter-spacing: 1px;
		margin-bottom: 10px;
	}

	.seelicense-item3 li {
		width: 350px;
	}

	.seelicense-item4 {
		margin: 0 35px;
		background: #f8f8fb;
		padding: 20px;
		list-style: none;
		color: #666;
		letter-spacing: 1px;
	}

	.seelicense-item4 li {
		margin-bottom: 10px;
	}

	.seelicense-item5 {
		padding-left: 35px;
		height: 32px;
		line-height: 32px;
		letter-spacing: 1px;
		color: #666;
	}

	.purchasesee-text1,
	.purchasesee-text2 {
		height: 32px;
		line-height: 32px;
		text-indent: 15px;
	}

	.purchasesee-text2 {
		text-indent: 50px;
	}

	.purchasesee-table {
		width: 50%;
		margin: 10px 0 30px 50px;
	}

	.purchasesee-linceinfo {
		margin: 10px 50px;
		display: flex;
		display: -webkit-flex;
	}

	.purchasesee-linceitem {
		width: 30%;
	}

	.purchasesee-linceitem:nth-child(2) {
		margin: 0 3%;
	}

	.organ-box {
		margin-bottom: 20px;
		text-align: right;
	}

	.apply-box {
		display: flex;
		display: -webkit-flex;
	}

	.apply-box p {
		flex: 1;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	/deep/ .carInformationDialog .el-dialog .el-dialog__body {
		height: 450px;
		overflow: auto;
	}
</style>
